import { render, staticRenderFns } from "./SchoolCreate.vue?vue&type=template&id=e1f30312&"
import script from "./SchoolCreate.vue?vue&type=script&lang=ts&"
export * from "./SchoolCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports